import { make } from "vuex-pathify"

import AccountsAPI from "@/api/accounts"

const state = () => {
  return {
    adAccounts: [],
    businesses: [],

    busy: false,
    businessId: null,
    adAccountId: null,
  }
}

const actions = {
  clearModule({ commit }) {
    commit("CLEAR_MODULE")
  },

  loadBusinesses({ commit }) {
    commit("SET_BUSY", true)

    return AccountsAPI.getBusinesses()
      .then(response => {
        commit("SET_BUSINESSES", response)
      })
      .finally(() => {
        commit("SET_BUSY", false)
      })
  },

  loadAdAccounts({ commit, state }) {
    if (state.businessId) {
      commit("SET_BUSY", true)

      return AccountsAPI.getAdAccounts(state.businessId)
        .then(response => {
          commit("SET_AD_ACCOUNTS", response)
        })
        .finally(() => {
          commit("SET_BUSY", false)
        })
    }
  },

  setAdAccountId({ commit }, adAccountId) {
    commit("SET_AD_ACCOUNT_ID", adAccountId)
  },
}

const getters = {
  ...make.getters(state),

  findAdAccount: state => item => {
    const id = typeof item === "object" ? item.id : item

    return state.adAccounts.find(i => i.id === id)
  },

  findBusiness: state => item => {
    const id = typeof item === "object" ? item.id : item

    return state.businesses.find(i => i.id === id)
  },

  isAdAccountConnected(state) {
    return !!state.businessId && !!state.adAccountId
  },
}

const mutations = {
  ...make.mutations(state),
  CLEAR_MODULE(state) {
    state.adAccounts = []
    state.businesses = []
    state.busy = false
    state.businessId = null
    state.adAccountId = null
  },
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
